import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { User } from '../../../models/user';
import { Router } from '@angular/router';
import { IframeDataModel } from '../../../models/common';
import { apiEndpoints } from '../../app.constants';
import * as Sentry from '@sentry/browser';
import { ObjectUtils } from '../../utils/object.utils';

@Component({
  selector: 'achoo-iframe',
  templateUrl: './achoo-iframe.component.html',
  styleUrls: ['./achoo-iframe.component.scss']
})
export class AchooIframeComponent implements OnInit {
  @Input() source: string;
  public safeSource: SafeResourceUrl;

  constructor(
    public sanitizer: DomSanitizer,
    private router: Router) {
      if (window.addEventListener) {
        window.addEventListener('message', this.receiveMessage.bind(this), false);
      } else {
         (<any>window).attachEvent('onmessage', this.receiveMessage.bind(this));
      }
    }

  private goToPost(influencerId: number, fullUrl: string, relativePath: string) {
    this.router.navigate(['post'], {queryParams: {influencerId, fullUrl, relativePath}});
  }

  private receiveMessage(event: MessageEvent) {
    if (event.origin !== environment.iframeHost) {
      return;
    }

    const data = event.data as IframeDataModel;

    // Post handler
    if (data.page === 'post_page') {
      this.goToPost(data.details.influencer_id, data.details.url, data.details.relative_path);
    }
  }

  ngOnInit() {
    if (!localStorage.getItem('user')) {
      return;
    }

    const user = ObjectUtils.parseJSON(localStorage.getItem('user')) as User || false;

    if (!user) {
      Sentry.captureException(new Error('[BAD STATE] An invalid user object was stored in localstorage'));
      return;
    }

    const url = '/#' + apiEndpoints.authorizeByToken + '?token=' + user.token + '&path=' + this.source + '&framed=true';
    this.safeSource = this.sanitizer.bypassSecurityTrustResourceUrl(environment.iframeHost + url);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-iframe/achoo-iframe.component.ts